export default {"src":"/_next/static/media/benzinga_crypto.2df27b2a.svg","height":85,"width":721,"blurWidth":0,"blurHeight":0};